// @NOTE: All code should migrate to using values from this file

export enum AccountType {
  AirTransportProviderHoldingAccount = 'airTransportProviderHoldingAccount',
  FuelProviderHoldingAccount = 'fuelProviderHoldingAccount',
  GeneralHoldingAccount = 'generalHoldingAccount',
  LogisticsProviderHoldingAccount = 'logisticsProviderHoldingAccount',
}

export const AccountTypeToLabel = {
  [AccountType.AirTransportProviderHoldingAccount]:
    'Air Transport Provider Holding Account',
  [AccountType.FuelProviderHoldingAccount]: 'Fuel Provider Holding Account',
  [AccountType.GeneralHoldingAccount]: 'General Holding Account',
  [AccountType.LogisticsProviderHoldingAccount]:
    'Logistics Provider Holding Account',
};

export enum AccountMembershipRole {
  AccountRepFullAccess = 'accountRepFullAccess',
  AccountRepApprover = 'accountRepApprover',
  AccountRepInitiator = 'accountRepInitiator',
  ReadOnly = 'readOnly',
}

export const accountRoleToString = {
  [AccountMembershipRole.AccountRepFullAccess]: 'Initiate and approve',
  [AccountMembershipRole.AccountRepInitiator]: 'Initiate only',
  [AccountMembershipRole.AccountRepApprover]: 'Approve only',
  [AccountMembershipRole.ReadOnly]: 'Read only',
};

export const accountRoleToDescription = {
  [AccountMembershipRole.AccountRepFullAccess]: 'Can initiate, sign, and accept a transaction.',
  [AccountMembershipRole.AccountRepInitiator]: 'Can only initiate a transaction.',
  [AccountMembershipRole.AccountRepApprover]: 'Can sign and accept a transaction.',
  [AccountMembershipRole.ReadOnly]: 'Cannot interact \n with units.',
};
